import React from 'react'
import { useForm } from "react-hook-form";
import { useUserLoginMutation } from "../../../services/userAuth";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { setUserCredentials } from "../LoginAuthSlice";
import { CLIENT_ROUTES, HOME_ROUTE } from "../../../config/routes";
import LoginFormController from "./LoginFormController";
import { LOGIN_FORM_KEYS } from "./FormConfig";

import { ReactComponent as MailIcon } from "./assets/MailIcon.svg"
import { ReactComponent as LockIcon } from "./assets/Lock.svg"
import SignInButton from "./components/button/SignInButton";
import ClientLoginLayout from "../../../layouts/client/login/ClientLoginLayout";


function Login() {

  const { control, handleSubmit, formState: { errors } } = useForm();
  const [login] = useUserLoginMutation()
  const dispatch = useDispatch()
  const { state } = useLocation()
  const navigate = useNavigate()


  const emailVerifyRegex = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z]+$/i

  const onSubmit = async data => {
    const loginResponse = await login(data).unwrap()
    if (loginResponse?.user) {
      const { user } = loginResponse
      dispatch(setUserCredentials({ user }))
      const pathname = state?.from?.pathname ?? HOME_ROUTE
      navigate(pathname)
    }
  };

  return (
    <ClientLoginLayout>
      <div className='LoginForm'>
        <h3 className="WelcomeText text-2xl font-medium py-5 ">CLIENT LOGIN PORTAL</h3>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className='pb-4'>

            <LoginFormController name={LOGIN_FORM_KEYS.Email} control={control} rules={{ required: true, pattern: emailVerifyRegex }} label='Email' id='emailInput' icon={<MailIcon />} errors={errors.email} enableShowPassword={false} />
            <span className="font-medium text-sm pl-2">{errors.email && `Please Enter a Valid Email`}</span>
          </div>
          <LoginFormController name={LOGIN_FORM_KEYS.Password} control={control} rules={{ required: true }} label='Password' id='passwordInput' icon={<LockIcon />} errors={errors.email} enableShowPassword={true} />

          <span className="font-medium pl-2 text-sm">{errors.password && `This is a required field`}</span>
          <div className="flex justify-content-end font-medium text-sm ">
            <p onClick={() => navigate(CLIENT_ROUTES.CLIENT_FORGOT_PASSWORD)} className='ForgotPassword cursor-pointer'>
              Forgot Password?
            </p>
          </div>
          <div className="flex justify-content-end">
            <SignInButton label='Sign In' type="submit" />
          </div>
        </form>
      </div>
    </ClientLoginLayout>
  )
}

export default Login